import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
    Router,
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root',
})
export class AuthClientCryptoGuard implements CanActivate {
    constructor(
        private readonly authService: AuthService,
        private readonly router: Router,
        private toastr: ToastrService
    ) { }

    canActivate(
        _route: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot,
    ): boolean | UrlTree {
        const user = this.authService.getAuthenticatedUser();

        if (!user || !user.token) {
            this.toastr.warning('Usuário não autenticado. Redirecionando para login.');
            return this.router.parseUrl('/login');
        }

        if (!this.authService.isTokenValid(user.token)) {
            this.toastr.warning('Token expirado. Redirecionando para login.');
            this.authService.removeAuthenticatedUser();
            return this.router.parseUrl('/login');
        }

        if (user.role !== 'CLIENT_CRYPTO') {
            this.toastr.warning(`Role inválida: ${user.role}. Acesso negado.`);
            return this.router.parseUrl('/login');
        }

        return true;
    }
}
